import React, { useMemo } from 'react';
import {
  Row,
  Col,
  Divider,
} from 'antd';

import HoverHelp from '../../common/HoverHelp';
import OnTraccrSwitch from '../../common/inputs/OnTraccrSwitch';

export default ({
  autoImport,
  setAutoImport,
  setActivePanels,
  helpContent,
  importData,
  importType,
}) => {
  const {
    importCount,
    linkCount,
  } = useMemo(() => {
    const {
      importList = [],
    } = importData;

    let iCount = 0;
    let lCount = 0;
    importList.forEach(({ linkValue }) => {
      if(linkValue) {
        lCount += 1;
      } else {
        iCount += 1;
      }
    });
    return { importCount: iCount, linkCount: lCount };
  }, [importData]);

  return (
    <Row style={{ width: '100%'}}>
      <Row style={{ width: '100%', paddingTop: 5 }} justify='start' align='middle' gutter={10}>
        <Col style={{ paddingLeft: 10 }}>
          <OnTraccrSwitch
            value={autoImport}
            onChange={(checked) => {
              if(!checked) {
                setAutoImport(false);
                setTimeout(() => {
                  setActivePanels(['new']);
                }, 250);
              } else {
                setActivePanels([]);
                setTimeout(() => {
                  setAutoImport(true);
                }, 250);
              }
            }}
            title={(
              <>
                Auto Import
                { helpContent && (
                  <HoverHelp
                    content={helpContent}
                    placement='rightTop'
                    iconProps={{ style: { marginLeft: 10 } }}
                  />
                )}
              </>
            )}
          />
        </Col>
        <Col style={{ marginLeft: 20,  }}>
          <div>Importing <b>{importCount}</b> {importType}{importCount === 1 ? '' : 's'}</div>
        </Col>
        <Col style={{ marginLeft: 20,  }}>
          <div>Linking <b>{linkCount}</b> {importType}{linkCount === 1 ? '' : 's'}</div>
        </Col>
      </Row>
      <Divider/>
    </Row>
  );
}